import React, { useState, useEffect, useCallback, useRef } from "react";
import Logo from "../images/logo.svg";
import { SelectPicker, Placeholder, Button } from "rsuite";
import Sidebar from '../component/Sidebar';
import "rsuite/SelectPicker/styles/index.css";
import IconNoData from "../images/IconNoData.svg";
import debounce from 'lodash.debounce';
import 'aos/dist/aos.css';
import AOS from 'aos';
import { useParams, Link, useNavigate} from "react-router-dom";
import { ChakraProvider, useToast, Wrap } from '@chakra-ui/react'
import imgBack from "../images/icon-back.svg";

const ProfileDetails  = () => {
    const navigate = useNavigate();

    const [tabName, setTabName] = useState('ETF Profile Details');
    
        useEffect(() => {
          document.title = tabName;
        }, [tabName]);

    const { flagName } = useParams();
    const [isLoading, setLoading] = useState(true); // State to manage loading state
    const [currentPage, setCurrentPage] = useState(1);
    const [query, setQuery] = useState(""); // New state for search query
    const [countryData, setCountryData] = useState([]);
    const [reportdata, setReportData] = useState([]);
    const [reportCount, setReportCount] = useState(0);
    
        const [pageRange, setPageRange] = useState("20");
const [customPaginationValue, setCustomPaginationValue] = useState("");
const abortControllerRefGlobal = useRef(null);
const [searchQuery, setSearchQuery] = useState("");

const userid = localStorage.getItem("novauserid");
const [countryCode, setCountryCode] = useState("");
const apiEndPoint = process.env.REACT_APP_ETF_API_ENDPOINT;

const handleCountryChange = (value) => {
    setCountryCode(value);
};


         const toast = useToast()
         const toastIdRef = React.useRef()

useEffect(() => {
    AOS.init();
  }, []);

         useEffect(() => {
             fetchGlobalReport();
              // Set up interval to call the function every minute (60000 ms)
              const intervalId = setInterval(fetchGlobalReport, 60000);
              // Clear the interval when the component unmounts or dependencies change
              return () => clearInterval(intervalId);
         
             
           }, [currentPage, query,countryCode]);
         
           useEffect(() => {
            const handleBeforeUnload = () => {
                abortControllerRefGlobal.current = null; 
            };
        
            window.addEventListener("beforeunload", handleBeforeUnload);
        
            return () => {
                window.removeEventListener("beforeunload", handleBeforeUnload);
                if (abortControllerRefGlobal.current) {
                    abortControllerRefGlobal.current.abort();
                }
            };
        }, []);

            const fetchGlobalReport = async () => {

                setLoading(false);

                // Cancel the previous request if any
                if (abortControllerRefGlobal.current) {
                abortControllerRefGlobal.current.abort();
                }

                // Create a new AbortController for the current request
                const controller = new AbortController();
                abortControllerRefGlobal.current = controller;


                try {
                
                const apiUrl = `${apiEndPoint}/etf_profile_analytic_detail`;
                const requestData = {
                    data: {
                    limit: "20",
                    page: currentPage.toString(),
                    order: "DESC",
                    q: query || "",
                    flag:flagName.toString(),
                    country:countryCode || "",
                    }
                };

                //console.log(JSON.stringify(requestData));

                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(requestData),
                    signal: controller.signal
                });
                
                const jsonData = await response.json();
                if (jsonData.data.status === "success") {
                    setLoading(false);
                    setReportCount(jsonData.data.count);
                    setReportData(jsonData.data.data);
                } else {
                    setLoading(false);
                    toastIdRef.current = toast({ description: jsonData.data.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
                    return false;
                }
                } catch (error) {
                if (error.name === "AbortError") {
                    setLoading(false);
                    console.log("Global Request cancelled");
                    //toastIdRef.current = toast({ description: "Request Cancelled", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
                }
                else{
                    setLoading(false);
                    toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
                }
                return false;
                }
            };


useEffect(() => {
        const fetchCountryList = async () => {
          const url = `${apiEndPoint}/get_country_list_etf`;
          const payload = {
            data: {
              user_id: userid // Replace with the actual user_id if dynamic
            }
          };
      
          try {
            const response = await fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            });
      
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
      
            const responseData = await response.json();
            const data = responseData.data; // Flatten the response
    
            const formattedCountryData = data.data.map((country) => ({
              label: country.country_name,
              value: country.country_code,
            }));
    
            setCountryData(formattedCountryData);
      
          } catch (error) {
            toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
            return false;
          }
        };
      
        fetchCountryList();
      }, []);

 const handleSearchChange = (event) => {
    setQuery(event.target.value); // Update the search query state
    setCurrentPage(1); // Reset to first page on search change
};


const handleClearFilters = () => {
    setCurrentPage(1);
    setQuery("");
    setCountryCode("");
};


const handlePagelimit = (value) => {
    setCurrentPage(1);
    setCustomPaginationValue(1);
    setPageRange(value);
};

const handlePaginationChange = (e) => {
    const value = (e.target.value == 0 ? 1 : e.target.value).toString();
    setCustomPaginationValue(value); // Update input value immediately for fast typing
    debouncedSetPage(Number(value)); // Trigger the debounced function
};

 // Debounced function to update the page number
    const debouncedSetPage = useCallback(
        debounce((page) => {
            setCurrentPage(page);
        }, 500), // Delay of 500ms (half a second)
        []
    );

const PagingData = ['10', '20', '50', '100'].map(
    item => ({ label: item, value: item })
);


  const renderPagination = () => {
        // Calculate total number of pages
        const totalPages = Math.ceil(reportCount / pageRange);

        // Show a default of 3 pages if the total pages are more than 3
        const pageNumbers = [];
        const visiblePageCount = 4; // Number of pages to show by default

        let startPage = currentPage - 1;
        let endPage = currentPage + 2;

        // Adjust pagination if total pages are less than the default
        if (totalPages <= visiblePageCount) {
            startPage = 1;
            endPage = totalPages;

        } else {

            // Ensure the pagination does not go out of bounds
            startPage = Math.max(1, startPage);
            endPage = Math.min(totalPages, endPage);
        }

        // Create page numbers to display based on current page
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        return (
            <nav aria-label="..." id='pagination_row' style={{ alignItems: 'center', justifyContent: 'space-between', background: '#FFF', paddingTop: 0, paddingBottom: 0 }}>
                <div className='totalRecords'>
                    Total Records : {Number(reportCount).toLocaleString()}
                </div>
                <ul className="pagination" style={{ border: 0, background: 'none' }}>

                    <li class="page-item" style={{ marginLeft: 10 }}>
                        <SelectPicker onChange={handlePagelimit} cleanable={false}
                            value={pageRange}
                            placement="top" placeholder='Pages' data={PagingData} searchable={false} style={{ width: 85, height: 35, display: 'flex', alignItems: 'center', borderRadius: 5, border: '1px solid #A1B9ED' }} />
                    </li>

                    {/* Previous Page (Double Arrow) */}
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`} style={{ marginLeft: 10 }}>
                        <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
                            <i className="fa fa-angle-double-left"></i>
                        </a>
                    </li>

                    {/* Previous Page (Single Arrow) */}
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <a href="#" className="page-link" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}>
                            <i className="fa fa-angle-left"></i>
                        </a>
                    </li>

                    {/* Page numbers */}
                    {pageNumbers.map(page => (
                        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                            <a
                                className="page-link" href="#"
                                onClick={() => setCurrentPage(page)} // Set the clicked page as the current page
                            >
                                {page}
                            </a>
                        </li>
                    ))}

                    {/* Next Page (Single Arrow) */}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <a href="#" className="page-link" onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}>
                            <i className="fa fa-angle-right"></i>
                        </a>
                    </li>

                    {/* Next Page (Double Arrow) */}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`} style={{ marginRight: 10 }}>
                        <a href="#" className="page-link" onClick={() => setCurrentPage(totalPages)}>
                            <i className="fa fa-angle-double-right"></i>
                        </a>
                    </li>

                    {/* Go to Page */}
                    <li className="page-item" style={{ marginLeft: 10, display: 'flex', alignItems: 'center', gap: 5 }}>
                        <input
                            type="text"
                            placeholder="Go#"
                            className="form-control"
                            value={customPaginationValue}
                            onChange={handlePaginationChange}
                            onInput={(e) => {
                                // Only allow numbers
                                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                            }}

                            style={{
                                padding: '0px 10px',
                                color: '#878787',
                                fontSize: 16,
                                borderRadius: 5,
                                border: '1px solid #A1B9ED',
                                width: 60,
                                height: 35,
                                textAlign: 'center'
                            }}
                        />
                    </li>
                </ul>
            </nav>
        );
    };

    const flagTextMap = {
        zeroholdings: "ETF Profile With Zero Holdings",
        missingaum: "ETF Profile Missing AUMs",
        convertedetf: "ETF Profile With Currency Conversions",
        failbycba: "ETF Profile With Failed CBA ETFs",
        dataerror: "ETF Profile With Data Errors",
      };

      const handleBack = async () => {
        navigate("/ETFAnalytics");
      };


  return (
   <>
    <Sidebar />
            <div id="header">
            <div className='logo'>   
            <Button className='btn_Back_head' onClick={handleBack}><img src={imgBack}/></Button>
                <div className="logo">
                    <div className="logo_icon">
                        <img src={Logo} alt="Logo" />
                    </div>
                    <div className="brand_name">{flagTextMap[flagName] || "ETF Profile Details"}</div>
                </div>
                </div>
                <div className="header_table_filter">
                    <div className="searchfield">
                        <button className="btn_search"><i className="icon-search2"></i></button>
                        <input
                            type="text"
                            className="filter_searchfield"
                            placeholder="Search"
                            value={query} // Bind the input value to the search query state
                            onChange={handleSearchChange} // Handle change event
                        />
                    </div>

                    <div className="dropdown_style filter_by_country">
                                <SelectPicker
                                data={countryData}
                                searchable={false}
                                style={{width:170}}
                                placeholder="Filter by Country"
                                onChange={handleCountryChange}
                                value={countryCode}
                                />
                            </div>
                    {/* <div className="dropdown_col_filter dropdown_select" style={{ width: 'auto', padding: 0 }}>
                        <SelectPicker
                            data={countryData}
                            searchable={false}
                            placeholder="Download Reports"
                            style={{ width: 180 }}
                        />
                    </div> */}

                    {/* <div className="dropdown_col_filter dropdown_select" style={{ width: 'auto', padding: 0 }}>
                        <SelectPicker
                            data={standardData}
                            searchable={false}
                            placeholder="Filter by Date"
                            style={{ width: 180 }}
                        />
                    </div>

                    <div className="dropdown_col_filter dropdown_select" style={{ width: 'auto', padding: 0 }}>
                        <SelectPicker
                            data={standardData}
                            searchable={false}
                            placeholder="Status - Based Filtering"
                            style={{ width: 205 }}
                        />
                    </div> */}


                    <a href="javascript:void(0)" className="btn_clear_filter" style={{ textDecoration: "none" }} onClick={handleClearFilters}>
                        Clear Filters
                    </a>
                </div>
            </div>
            <div className="container-fluid content pb-5">

                <div className="company_table_list" data-aos="fade-up" data-aos-duration="600">
                    {isLoading && (<Placeholder.Grid rows={20} columns={9} active style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }} />)}

                    {/* Table */}
                    {!isLoading && (
                        <>
                            <div className="table-responsive clsPagingWrap">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className="text-center">Symbol</th>
                                            <th className="text-center">ISIN</th>
                                            <th >Name</th>
                                            <th className="text-center">Asset Class</th>
                                            <th style={{ textAlign: 'center' }}>Country</th>
                                            {flagName === "convertedetf" && (
                                                <th style={{ textAlign: 'center' }}>Calculated Currency</th>
                                            )}
                                            {flagName === "dataerror" && (
                                                <th style={{ textAlign: 'center' }}>Status</th>
                                            )}

                                            {/* <th style={{ textAlign: 'center' }}>Holding Count</th>
                                            <th style={{ textAlign: 'center' }}>View Holdings</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {reportdata && reportdata.length === 0 ? (
                                       <td colSpan="5" style={{ textAlign: "center", fontSize:20, paddingTop:30, paddingBottom:30 }}>
                                       No data available
                                     </td>
                                    ) : (
                                        reportdata &&
                                        reportdata.map((item, index) => (
                                            <>
                                                                <tr>
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        <span className="stock_lable" style={{ fontWeight: 600, textTransform: 'uppercase', width: 120, marginLeft:'auto', marginRight:'auto' }}>{item.symbol}</span>
                                                                    </td>
                                                                    <td>
                                                                        <div className="text-center">
                                                                        {item.isin}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                         <Link to={`/ETFHolding/${item.symbol}`} className='etf_name '>{item.name}</Link>
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', color: '#2D2D2D' }}>
                                                                        {/* <div className="calculate__status">Success</div> */}
                                                                        {item.asset_class}
                                                                    </td>
                                                                    
                                                                    <td  style={{ color: '#2D2D2D' ,textAlign: 'center' }}> {item.domicile}</td>
                                                                     {flagName === "convertedetf" && (
                                                                        <td style={{ color: '#2D2D2D', textAlign: 'center' }}>{item.currency_calculated}</td>
                                                                 )}         
                                                                     {flagName === "dataerror" && (
                                                                        <td style={{ color: '#2D2D2D', textAlign: 'center' }}>{item.api_status}</td>
                                                                 )}         

                                                                    {/* <td>
                                                                        <div className="btn__action__group">
                                                                            <a href="#" className="btn_create_report">View Holdings</a>
                                                                        </div>
                                                                    </td> */}
                                                                </tr>
                                                                </>
                                                            ))
                                                            )}

                                    </tbody>
                                </table>
                            </div>

                            {reportCount > 0 && renderPagination()}

                        </>
                    )}
                </div>

            </div>
   </>
  );
};

export default ProfileDetails ;
